import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { TadAuthProvider } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { IdCardType } from "../../../../api/graphql";
import { ShowMultiLine } from "../../../common/controls";
import { Gender } from "../../../../api/graphql";
import { FormControl } from "@mui/material";

export type TadManagerConfigViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  authProviderOptions: { id: string; displayId: string }[];
  authProvider: TadAuthProvider | "";
  idCardTypeOptions: { id: string; displayId: string }[];
  idCardType: IdCardType | "";
  idCardValue?: { displayId: string; id: string } | null;
  idCard: string;
  genderOptions: { id: string; displayId: string }[];
  gender: Gender | "";
};

export const TadManagerConfigViewForm: React.FC<TadManagerConfigViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      authProviderOptions = [],
      authProvider = "" as TadAuthProvider | "",
      idCardTypeOptions = [],
      idCardType = "" as IdCardType | "",
      idCard = "",
      genderOptions = [],
      gender = "" as Gender | "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupTadManagerConfigLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowString
                  value={
                    authProvider
                      ? authProviderOptions.find(
                          (o: { id: string }) => o.id === authProvider
                        )?.displayId || authProvider
                      : ""
                  }
                  label={langStore.TadManagerConfigAuthProviderLabel}
                />
                <ShowString
                  value={
                    idCardType
                      ? idCardTypeOptions.find(
                          (o: { id: string }) => o.id === idCardType
                        )?.displayId || idCardType
                      : ""
                  }
                  label={langStore.TadManagerConfigIdCardTypeLabel}
                />
                <ShowMultiLine
                  value={idCard}
                  label={langStore.TadManagerConfigIdCardLabel}
                />

                <ShowString
                  value={
                    gender
                      ? genderOptions.find(
                          (o: { id: string }) => o.id === gender
                        )?.displayId || gender
                      : ""
                  }
                  label={langStore.TadManagerConfigGenderLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
